import { Header } from "components/atoms/Typography";
import usePlansState from "recoilStore/Building/usePlansState";
import AnnualCarbonEmissionsOutcomes from "./OutcomesCards/AnnualCarbonEmissionsOutcomes/AnnualCarbonEmissionsOutcomes";
import AnnualCashFlowOutcomesChart from "./OutcomesCards/AnnualCashFlowOutcomes/AnnualCashFlowOutcomes";
import CapitalCard from "./OutcomesCards/CapitalCard/CapitalCard";
import CarbonPenaltiesCard from "./OutcomesCards/CarbonPenalties/CarbonPenaltiesCard";
import CostsCard from "./OutcomesCards/Costs/CostsCard";
import EnergyOutcomesChart from "./OutcomesCards/Energy/EnergyCard";
import styles from "./OutcomesV1.module.scss";

function OutcomesV1() {
    const { referencePlanName, comparedPlanName } = usePlansState();

    return (
        <div className={styles.outcomesPage}>
            <Header>
                {referencePlanName} compared to {comparedPlanName}
            </Header>

            <div className={styles.dashboard}>
                <div className={styles.outcomesColumn}>
                    <CapitalCard />
                    <CostsCard />
                    <CarbonPenaltiesCard />
                </div>

                <div className={styles.outcomesColumn}>
                    <AnnualCashFlowOutcomesChart />
                    <AnnualCarbonEmissionsOutcomes />
                    <EnergyOutcomesChart />
                </div>
            </div>
        </div>
    );
}

export default OutcomesV1;
